import clsx from "clsx";
import PropTypes from "prop-types";

import { RadioButton } from "@transfr-inc/dashboard-components/forms";

import { JobOutlook } from "@features/career-details/components";
import { ContextMenu, ContextMenuOption, ListItem } from "@features/ui";
import { compactCurrencyFormat } from "@lib/text.helpers";

import { CareerOptionType } from "../types";

import "./career-option.item.scss";

const getLastSchoolStep = (career) => {
  const schoolSteps = career?.pathwaySteps?.filter((step) => step.isSchoolStep);

  return schoolSteps?.length > 0 ? schoolSteps.at(-1) : undefined;
};

export const CareerOptionItem = ({
  career,
  onCareerDetailsClick,
  onCareerSelected,
  onRemoveCareerToCompare,
}) => {
  const contextMenu = (
    <ContextMenu>
      <ContextMenuOption
        icon={["fasr", "eye"]}
        label="View Career Detail"
        onClick={() => onCareerDetailsClick(career)}
      />
      {onRemoveCareerToCompare && (
        <ContextMenuOption
          icon={["fa-regular", "trash-can"]}
          label="Remove from Compare"
          onClick={() => onRemoveCareerToCompare(career)}
        />
      )}
    </ContextMenu>
  );

  return (
    <ListItem
      className={clsx("career-option-item", career?.isSelected && "active")}
      icon={contextMenu}
    >
      <RadioButton
        checked={career?.isSelected}
        className="career-option-item-content"
        name="career-option"
        value={career?.id}
        onChange={() => onCareerSelected(career)}
      >
        <div className="career-option-item-title">{career?.title}</div>
        <ul>
          <li>
            School:{" "}
            <span>{getLastSchoolStep(career)?.label ?? "Not Available"}</span>
          </li>
          <li>
            Outlook: <JobOutlook value={career?.outlook} />
          </li>
          <li>
            Average Salary:{" "}
            <span>
              {compactCurrencyFormat(career?.annualEarningsMedian, {
                maximumFractionDigits: 0,
              })}
            </span>
          </li>
        </ul>
      </RadioButton>
    </ListItem>
  );
};

CareerOptionItem.propTypes = {
  career: CareerOptionType.isRequired,
  onCareerDetailsClick: PropTypes.func.isRequired,
  onCareerSelected: PropTypes.func,
  onRemoveCareerToCompare: PropTypes.func,
};
